import React from "react";
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";
import App from "./App";
import "./index.css";
import reportWebVitals from "./reportWebVitals";

import { PostHogProvider } from "posthog-js/react";

const options = {
	api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
};

const queryClient = new QueryClient();
ReactDOM.render(
	<React.StrictMode>
		<PostHogProvider
			apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
			options={options}
		>
			<QueryClientProvider client={queryClient}>
				<App />
				<ReactQueryDevtools />
			</QueryClientProvider>
		</PostHogProvider>
	</React.StrictMode>,
	document.getElementById("root")
);
reportWebVitals();
